import { salesTwoRanges } from '@/app/shared/Services.js'
import OneDimensionStrategy from '@/app/shared/models/OneDimensionStrategy'
import PayloadParametersBuilder from '@/app/shared/models/PayloadParametersBuilder'

import WeeklyComparativeAgGrid from './models/WeeklyComparativeAgGrid.js'

const getWeeklyGrid = async ({ normalMetric, dimension, strategyFilter, filters, dateFilters, dateDimensions }) => {
  const weeklyGridPayload = buildWeeklyGridParameters({ normalMetric, dimension, strategyFilter, filters, dateFilters, dateDimensions })
  const weeklySalesComparativeGrid = await salesTwoRanges(weeklyGridPayload)
  return new WeeklyComparativeAgGrid(weeklySalesComparativeGrid, normalMetric)
}

const buildWeeklyGridParameters = ({ normalMetric, dimension, strategyFilter, filters, dateFilters, dateDimensions }) => {
  const oneDimensionStrategy = new OneDimensionStrategy(dimension, strategyFilter)
  const metrics = {
    normal: [normalMetric]
  }
  const payloadParametersBuilder = new PayloadParametersBuilder({ metrics, factTableName: 'dw_weekly_sales', filters, pivot: 'calendarweek', dateFilters, dateDimensions })
  const parameters = payloadParametersBuilder.build(oneDimensionStrategy)
  // TODO: Find the way how to fix this, maybe it will need some backend as the long-grid that bring the retail_id as dimension
  // when it sends the retail_name
  if (dimension.type === 'store') {
    parameters.store_dimensions.push(dimension.key)
  } else {
    parameters.product_dimensions.push(dimension.key)
  }
  return { parameters }
}

export { getWeeklyGrid }



// WEBPACK FOOTER //
// ./src/app/weekly_sales/Services.js